import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Patients from '../../modules/Patients';
import CustomButtons from '../ui-elements/Buttons/CustomButtons';
import CustomDangerButton from '../ui-elements/Buttons/CustomDangerButton';
import CustomInput from '../ui-elements/input/CustomInput';
import CustomSelect from '../ui-elements/input/CustomSelect';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useToasts } from 'react-toast-notifications';
import Autocomplete from '../../components/Apt/Autocomplete/Autocomplete';
import { useParams } from 'react-router';
import { ImCross } from 'react-icons/im';
import { DatePicker } from 'antd';
import moment from 'moment';
import { FaCaretDown } from 'react-icons/fa';
// import 'antd/dist/antd.css'; // Import Ant Design styles
import LdcApi from '../../LdcApis';
import { BsFillCloudUploadFill } from 'react-icons/bs';
import { Spin } from 'antd';
import { use } from 'react';
import AutoAppointmentComplete from '../../components/Apt/AutoAppointmentComplete/AutoAppointmentComplete';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
 
const outcome = [
  { id: 'Pending', name: 'Pending' },
  { id: 'Upheld', name: 'Upheld' },
  { id: 'NotUpheld', name: 'Not Upheld' },
  

];
 
const validationSchema = yup.object().shape({
  // patientName: yup.string().required('Patient Name is required'),
  notes: yup.string().optional('Field is required.'),
  priority: yup.string().optional('Field is required.'),
  outComes: yup.string().optional('Field is required.'),
  department: yup.string().optional('Field To is required.'),
  outcome: yup.string().optional('Field is required.'),
  assignedTo: yup.string().optional('Field is required.'),
  selectDocument: yup.string().optional('Field is required.'),
});

function ComplaintForm({
  assignedData,
  patientJobDetails,
  setShowPatientForm,
  getComplaintsDetailsPatient,
  getCaegoryListStatus,
  getRoleListStatus,
  patientLoader,
}) {
  const { id } = useParams();
  useEffect(() => {
    document.title = 'Jobs List - LDC';
  }, []);
  console.log('patientJobDetails', patientJobDetails);
  console.log('getComplaintsDetailsPatient', getComplaintsDetailsPatient);
  // let newDatient;

  // if (patientJobDetails !== undefined) {
  //   newDatient = { ...patientJobDetails, patientName: ` ${patientJobDetails?.firstName} ${patientJobDetails?.lastName}` };
  // } else {
  //   newDatient = { patientName: `` };
  // }

  // const [newDatient, setNewDatient] = useState(null);
  // const [smsTemplate, setSmsTemplate] = useState(null);

  const { addToast } = useToasts();
  // const [patientFormData, setPatientFormData] = useState(newDatient);
  const [addJobDisabled, setAddJobDisabled] = useState(false);
  // const [patients, setPatients] = useState([]);
  const [isPatientList, setIsPatientList] = useState(false);
  const [patientList, setPatientList] = useState([]);

  const patientFullName = `${patientJobDetails?.firstName} ${patientJobDetails?.lastName}`;
  const [selectedPhotoFile, setSelectedPhotoFile] = useState([]);
  const [uploadPhotoError, setUploadPhotoError] = useState(false);

  const [deuDateError, setDueDateError] = useState(false);
  const photoUploadRef = useRef(null);
  const [patientName, setPatientName] = useState('');
  const [doctorName, setDoctorName] = useState('');
  const [doctorList, setDoctorList] = useState([]);
  const [isDoctorList, setIsDoctorList] = useState(false);
  const [doctorLoader, setDoctorLoader] = useState(false);
  const [documentTabData, setDocumentTabData] = useState([]);
  const [selectDocument, setSelectDocument] = useState('');
  const [attachmentLoader, setAttachmentLoader] = useState(false);

  const [replyDate, setReplyDate] = useState('');
  const [complaintDate, setComplaintDate] = useState(dayjs());
  const [deadlineDate, setDeadlineDate] = useState(dayjs());
  const [btnDisable, setBtnDisable] = useState(false);
  const [incidentClass, setIncidentClass] = useState(false);
  // const [deadlineDate, setDeadlineDate] = useState(dayjs().add(28, 'day'));
  const [acknowledgementDate, setAcknowledgementDate] = useState('');

  const [incidentDate, setIncidentDate] = useState('');
  const [appointmentDates, setAppointmentDates] = useState([]);
  const [showAutocomplete, setShowAutocomplete] = useState(false);
  // const complaintDate = dayjs().startOf('day'); // Set today
  // const deadlineDate = calculateDeadlineDate(complaintDate); // Set deadline date
  useEffect(() => {
    setSmsTemplate({
      patientName: '',
      fullName: patientFullName,
      mobile: '',
      email: '',
      doctorInvolved: '',
      dateOfComplaint: complaintDate
        ? dayjs(complaintDate).format('YYYY-MM-DD')
        : '',
      // acknowledgementDate: acknowledgementDate
      //   ? dayjs(acknowledgementDate).format('YYYY-MM-DD')
      //   : '',
      deadlineDate: deadlineDate
        ? dayjs(deadlineDate).format('YYYY-MM-DD')
        : '',
      acknowledgementDate: null,
      replyDate: null,
    });
  }, [patientJobDetails]);

  useEffect(() => {
    if (id) {
      id && fetchDocumentsTabData(id);
    }
  }, [id]);

  useEffect(() => {
    if (documentTabData.length > 0) {
    }
  }, [documentTabData]);
  // useEffect(()=>{
  //   Patients.getDoctorListForAddTaskList((response)=>{
  //     if (response?.status === 'success') {
  //       setAssignedData(response.data);
  //     } else {
  //       addToast('Error Occured while Job adding Patient Job.', { appearance: 'error' });
  //     }
  //   })
  // },[])

  function calculateDeadlineDate(startDate, workingDays = 28) {
    let currentDate = dayjs(startDate);
    let addedDays = 0;

    while (addedDays < workingDays) {
      if (currentDate.day() !== 0) {
        // Count only Monday-Saturday (skip Sundays)
        addedDays++;
      }
      currentDate = currentDate.add(1, 'day'); // Move to the next day **after** counting
    }

    return currentDate.subtract(1, 'day'); // Adjust for the last extra increment
  }

  useEffect(() => {
    setDeadlineDate(calculateDeadlineDate(complaintDate)); // Calculate deadline on mount
  }, [complaintDate]);

  // Example Usage:
  console.log(calculateDeadlineDate('2024-03-22', 28)); // Should return 23rd April 2024

  const today = dayjs().format('YYYY-MM-DD');
  const [smsTemplate, setSmsTemplate] = useState({
    patientId: '',
    // dateOfComplaint: complaintDate
    //   ? dayjs(complaintDate).format('YYYY-MM-DD')
    //   : '',
    dateOfComplaint: complaintDate.format('YYYY-MM-DD'),
    // deadlineDate: deadlineDate.format('YYYY-MM-DD'),
    appointmentId: '',
    complaintToId: '',
    acknowledgementDate: today,
    deadlineDate: deadlineDate.format('YYYY-MM-DD'),
    complaintToType: 'D',
    replyDate: today,
    outcome: '',
    notes: '',
  });

  console.log('deadlineDate', deadlineDate.format('YYYY-MM-DD'));
  const formInitialSchema = {
    patientName: `${smsTemplate?.patientName}`,
    priority: '',
    notes: '',
    outComes: '',
    department: '',
    outcome: '',
    assignedTo: '',
    selectDocument: '',
    mobile: `${smsTemplate?.mobile ? smsTemplate?.mobile : ''}`,
    email: `${smsTemplate?.email ? smsTemplate?.email : ''}`,
    doctorInvolved: `${smsTemplate?.doctorName ? smsTemplate?.doctorName : ''}`,
  };
  console.log('patientJobDetails', patientJobDetails);
  console.log('smsTemplate', smsTemplate);
  console.log('formInitialSchema', formInitialSchema);

  // const allPatients = () => {
  //   Patients.getAllPatients((response) => {
  //     if (response?.status === 'success') {
  //       setPatients(response?.data);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   allPatients();
  // }, []);
  // useEffect(()=>{
  // },[patients])

  const onSearchPatient = (e) => {
    let val = e.target.value;
    val = val.replace(/^\s/, '');
    setSmsTemplate((smsTemplate) => ({
      ...smsTemplate,
      fullName: val,
    }));
    setDocumentTabData([]);
    setSelectDocument('');
    let tempSuggestion = [];
    if (val.length >= 3) {
      Patients.getExistPatients(val, (response) => {
        if (response?.status === 'success') {
          if (response?.data.length > 0) {
            setIsPatientList(true);
            setPatientList(response.data);
          } else {
            setIsPatientList(false);
            setPatientList([]);
          }
        }
      });
    } else {
      setIsPatientList(false);
      setPatientList([]);
    }
  };

  const onPatientItem = (item, setFieldValue) => {
    setSmsTemplate({
      ...smsTemplate,
      patientId: item.id,
      patientName: item.fullName,
      fullName: item.fullName,
      // fullName: item.fullName,
      mobile: item.mobile,
      email: item.email,
    });
    // Update Formik fields
    setFieldValue('patientName', item.fullName);
    setFieldValue('mobile', item.mobile);
    setFieldValue('email', item.email);

    fetchDocumentsTabData(item.id);
    setPatientName(item.fullName + ` :: ${item.id}`);
    setIsPatientList(false);
    setPatientList([]);
  };
  const onDoctorItem = (item) => {
    console.log('itemdoc--->', item);
    // setDoctorName(item.firstName);
    setSmsTemplate({
      ...smsTemplate,
      doctorInvolved: item.name,
      // doctorInvolved: `${item.firstName + '' + item.lastName}`,
      complaintToId: item.id, // Update field
      complaintToType: item.type,
    });
    setIsDoctorList(false);
  };

  const onSearchDoctor = (e) => {
    let val = e.target.value.trim(); // Remove leading spaces
    setSmsTemplate({
      ...smsTemplate,
      doctorInvolved: val, // Update field
    });

    let tempSuggestion = [];

    if (val.length >= 3) {
      Patients.getStaffAndUser(val, (response) => {
        console.log('responseStaff', response);
        if (response?.status === 'success') {
          if (response?.data?.data?.length > 0) {
            console.log('hit');
            setIsDoctorList(true);
            setDoctorList(response.data?.data); // Store doctors in state
          } else {
            setIsDoctorList(false);
            setDoctorList([]); // No results found
          }
        }
      });
    } else {
      setIsDoctorList(false);
      setDoctorList([]); // Reset list if less than 3 chars
    }
  };

  const fetchDocumentsTabData = (id) => {
    setAttachmentLoader(true);
    LdcApi({
      method: 'GET',
      url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          setAttachmentLoader(false);
          setDocumentTabData(response?.data);
        }
      })
      .catch((error) => {});
  };
  const fetchAppointmentDates = (patientId) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetAppointmentDateByPatient?patientId=${patientId}`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        console.log('response', response);
        if (
          response?.data?.status?.isSuccess &&
          response?.data?.data?.length > 0
        ) {
          setAppointmentDates(response.data.data);
          setShowAutocomplete(true);
        } else {
          setShowAutocomplete(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching appointment dates:', error);
        setAppointmentDates([]);
        setShowAutocomplete(false);
      });
  };
 
  const submitComplaint = async (values) => {
    setBtnDisable(true);

    if (!smsTemplate.appointmentId) {
      setIncidentClass(true);
      addToast(' Please select incident date', {
        appearance: 'warning',
      });
      setBtnDisable(false);
      return; // Stop function execution
    }

    const complaintData = {
      ID: 0,
      patientId: smsTemplate.patientId,
      dateOfComplaint: smsTemplate.dateOfComplaint,
      appointmentId: smsTemplate.appointmentId,
      complaintToId: smsTemplate.complaintToId,
      complaintToType: smsTemplate.complaintToType || 'D',
      dateOfAcknowledged: smsTemplate.acknowledgementDate,
      deadLineToReply: smsTemplate.deadlineDate,
      finalReplyDate: smsTemplate.replyDate,
      outCome: smsTemplate.outcome,
      note: smsTemplate.notes,
    };

    console.log('complaintData', complaintData);

    const hasValidationError = Object.values(validationError).some(
      (err) => err === true
    );

    if (hasValidationError) {
      setBtnDisable(false);
      addToast('All Fields are mandatory to fill.', { appearance: 'warning' });
    } else {
      try {
        const res = await LdcApi({
          method: 'POST',
          url: 'PatientsComplaintTracker/UpsertPatientsComplaintTracker',
          data: complaintData,
        });

        if (res.data.status.isSuccess === true) {
          addToast('Complaint saved successfully.', { appearance: 'success' });

          setShowPatientForm(false);
          setPatientName('');
       
          getComplaintsDetailsPatient();
          // **Clear Local State**
          setSmsTemplate({
            patientId: '',
            dateOfComplaint: '',
            appointmentId: '',
            complaintToId: '',
            acknowledgementDate: '',
            deadlineDate: '',
            replyDate: '',
            outcome: '',
            notes: '',
          });
            setTimeout(() => {
        window.location.reload();
      }, 700);
          setPatientName('');
          setIncidentDate('');
          setSelectDocument('');
          setDocumentTabData([]);
          setIsPatientList(false);
          setPatientList([]);
        } else {
          addToast('Failed to save complaint.', { appearance: 'error' });
        }
      } catch (err) {
        console.log('err', err);
        addToast('Something went wrong. Please try again.', {
          appearance: 'error',
        });
      } finally {
        setBtnDisable(false);
      }
    }
  };

  const [validationError, setValidationError] = useState({
    patientName: false,
    notes: false,
    department: false,
    priority: false,
    outcome: false,
    assignedTo: false,
    doctorInvolved: false,

    // selectDocument:false,
  });
  console.log('validationError', validationError);
  const savePatient = () => {
    console.log('save');
  };
  // const savePatient = (values, resetForm) => {
  //   const formData = new FormData();
  //   let patientJobData = {
  //     patientName: smsTemplate.fullName,
  //     jobDetails: values.jobDetails,
  //     outComes: values.outComes,
  //     patientId:
  //       patientJobDetails.patientId === ''
  //         ? smsTemplate.patientId
  //         : patientJobDetails.patientId,
  //     assignedTo: values.department,
  //     priority: values.priority,
  //     status: 'Open',
  //     outcome: values.outcome,
  //     complaintToId: values.assignedTo,
  //     selectDocument: values.selectDocument,
  //   }; //assignedTo is department and newAssignedTo is assignedTo

  //   let isValid = false;
  //   let isValidation = {
  //     patientName: false,
  //     jobDetails: false,
  //     department: false,
  //     priority: false,
  //     outcome: false,
  //     assignedTo: false,
  //     // selectDocument:false,
  //   };

  //   if (patientJobData.patientName === '') {
  //     isValidation.patientName = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }

  //   if (values.jobDetails === '') {
  //     isValidation.jobDetails = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }
  //   if (values.department === '') {
  //     isValidation.department = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }
  //   if (values.outcome === '') {
  //     isValidation.outcome = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }

  //   if (values.assignedTo === '') {
  //     isValidation.assignedTo = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }

  //   if (values.priority == '') {
  //     isValidation.priority = true;
  //     isValid = false;
  //   } else {
  //     isValid = true;
  //   }

  //   formData.append('patientName', smsTemplate.fullName);
  //   formData.append('jobDetails', values.jobDetails);
  //   formData.append('outComes', values.outComes);
  //   formData.append(
  //     'patientId',
  //     patientJobDetails.patientId === ''
  //       ? smsTemplate.patientId
  //       : patientJobDetails.patientId
  //   );
  //   formData.append('assignedTo', values.department);
  //   formData.append('priority', values.priority);
  //   formData.append('status', 'Open');
  //   formData.append('outcome', values.outcome);
  //   formData.append('complaintToId', values.assignedTo);
  //   selectedPhotoFile.forEach((file) => {
  //     formData.append('file', file);
  //   });
  //   formData.append('PAttachmentId', selectDocument);
  //   if (dueDate) {
  //     const originalDate = new Date(dueDate['$d']);
  //     const formattedDate = originalDate.toISOString();
  //     formData.append('dueDate', formattedDate);
  //   } else {
  //     setDueDateError(true);
  //   }
  //   setValidationError(isValidation);
  //   if (
  //     dueDate &&
  //     !isValidation.patientName &&
  //     !isValidation.department &&
  //     !isValidation.priority &&
  //     !isValidation.jobDetails &&
  //     !isValidation.outcome &&
  //     !isValidation.assignedTo
  //   ) {
  //     setAddJobDisabled(true);
  //     Patients.addJobsPatients(formData, (response) => {
  //       if (response?.status === 'success') {
  //         addToast('Task added successfully.', { appearance: 'success' });
  //         resetForm();
  //         setAddJobDisabled(false);
  //         setUploadPhotoError(false);
  //         getComplaintsDetailsPatient();
  //         getCaegoryListStatus();
  //         getRoleListStatus();
  //         photoUploadRef.current.value = null;
  //         setSelectedPhotoFile([]);
  //         setComplaintDate(null);
  //         setPatientName('');
  //         setDocumentTabData([]);
  //         setSelectDocument('');
  //         if (id === undefined) {
  //           setSmsTemplate({
  //             patientId: '',
  //             patientName: '',
  //             fullName: '',
  //             mobile: '',
  //           });
  //         }
  //         setShowPatientForm(false);
  //       } else {
  //         addToast('Error Occured while Job adding Patient Job.', {
  //           appearance: 'error',
  //         });
  //         setAddJobDisabled(false);
  //       }
  //     });
  //   } else {
  //     setAddJobDisabled(false);
  //   }

  //   if (isValid) {
  //     // Patients.addJobsPatients(patientJobData, (response) => {
  //     //   if (response?.status === 'success') {
  //     //     addToast('Patient Job is  added successfully.', { appearance: 'success' });
  //     //     resetForm();
  //     //     setAddJobDisabled(false);
  //     //     getComplaintsDetailsPatient();
  //     //   } else {
  //     //     addToast('Error Occured while Job adding Patient Job.', { appearance: 'error' });
  //     //     setAddJobDisabled(false);
  //     //   }
  //     // });
  //   } else {
  //     setAddJobDisabled(false);
  //   }
  // };
 
  useEffect(() => {
    setSmsTemplate((prevTemplate) => ({
      ...prevTemplate,
      dateOfComplaint: complaintDate.format('YYYY-MM-DD'),
      deadlineDate: deadlineDate.format('YYYY-MM-DD'),
    }));
  }, [complaintDate, deadlineDate]); // Trigger update when complaintDate changes

  const handleDateChange = (date) => {
    if (date) {
      setComplaintDate(date); // Store dayjs object
      setDeadlineDate(date.add(28, 'day'));
    }
  };

  const handleReplyDate = (date) => {
    if (date) {
      setReplyDate(date);

      setSmsTemplate((prev) => ({
        ...prev,
        replyDate: dayjs(date).format('YYYY-MM-DD'), // Convert to YYYY-MM-DD
      }));
    }
  };

  const handleDeadlineDateChange = (date) => {
    if (date) {
      setDeadlineDate(date);
    }
  };
  // const handleDateChange = (date) => {
  //   if (date) {
  //     // setComplaintDate(date); // Ensure `date` is a valid dayjs object
  //     setSmsTemplate((prev) => ({
  //       ...prev,
  //       dateOfComplaint: date.format('YYYY-MM-DD'),
  //     }));
  //   }
  // };
  const handleDateAcknowledgementChange = (date) => {
    if (date) {
      setAcknowledgementDate(date);
      setSmsTemplate((prev) => ({
        ...prev,
        acknowledgementDate: dayjs(date).format('YYYY-MM-DD'), // Convert to YYYY-MM-DD
      }));
    }
  };

  const handleIncidentDateClick = () => {
    if (!showAutocomplete) {
      fetchAppointmentDates(smsTemplate.patientId); // Fetch only when opening
    }
    setShowAutocomplete((prev) => !prev); // Toggle open/close
  };
  const handleSelectDate = (appointment, setFieldValue) => {
    const formattedDate = dayjs(appointment.appointmentDate).format(
      'DD/MM/YYYY'
    );
    setIncidentDate(formattedDate);
    // setIncidentDate(appointment.appointmentDate.split('T')[0]); // Format date
    setIncidentClass(false);
    setShowAutocomplete(false);
    console.log('appointment--->>', appointment);
    setSmsTemplate((prev) => ({
      ...prev,
      doctorInvolved: appointment.doctorName,
      complaintToId: appointment.doctorId,
      appointmentId: appointment.appointmentId,
      complaintToType: appointment.complaintToType
        ? appointment.complaintToType
        : 'D',
    }));
    setFieldValue('incidentDate', appointment.appointmentId);
    setFieldValue('doctorInvolved', appointment.doctorName);
  };
  console.log('showAutocomplete', showAutocomplete);

  return (
    <div>
      {smsTemplate ? (
        <Card className='p-3 mt-2'>
          <Formik
            enableReinitialize
            initialValues={formInitialSchema}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await submitComplaint(values, resetForm);
            }}
          >
            {({
              values,
              errors,
              resetForm,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form id='patientForm' onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <label>
                      Patient <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative' }}
                    >
                      <input
                        // style={{ borderColor: smsTemplate.fullName === '' ? 'red' : '' }}
                        autoFocus
                        disabled={patientJobDetails.firstName !== '' && true}
                        type='text'
                        name='patientName'
                        placeholder='Patient Name'
                        value={
                          patientJobDetails.firstName !== ''
                            ? patientJobDetails.firstName
                            : patientName
                        }
                        // onChange={handleChange}
                        className='form-control'
                        // onBlur={handleBlur}
                        // error={errors.patientName}
                        // touched={touched.patientName}
                        onChange={(e) => {
                          setPatientName(e.target.value);
                          onSearchPatient(e);
                        }}
                        // onClick={onSearchPatient}
                        required
                      />
                      {isPatientList && (
                        <div className='firstName-dropdown'>
                          <Autocomplete
                            type={patientList}
                            onFsListItem={(item) =>
                              onPatientItem(item, setFieldValue)
                            }
                          />
                        </div>
                      )}
                      {patientLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '6px',
                            right: '20px',
                            marginBottom: '0px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                      {validationError.patientName && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Mobile Number</label>
                    <Form.Group className='mb-3'>
                      <Form.Control
                        disabled
                        type='text'
                        name='mobile'
                        className='form-control'
                        placeholder='Mobile Number'
                        value={values.mobile}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isInvalid={!!errors.mobile && touched.mobile}
                        style={{ borderColor: errors.mobile ? 'red' : '' }}
                        required
                      />
                      {errors.mobile && touched.mobile && (
                        <Form.Control.Feedback type='invalid'>
                          {errors.mobile}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Email Id</label>
                    <Form.Group className='mb-3'>
                      <Form.Control
                        disabled
                        type='text'
                        name='email'
                        className='form-control'
                        placeholder='Email Id'
                        value={values.email}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isInvalid={!!errors.email && touched.email}
                        style={{ borderColor: errors.email ? 'red' : '' }}
                        required
                      />
                      {errors.email && touched.email && (
                        <Form.Control.Feedback type='invalid'>
                          {errors.email}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>
                      Date of Complaint <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Form.Group className='mb-3'>
                      <DatePicker
                        value={complaintDate} // Pass dayjs object directly
                        onChange={handleDateChange}
                        format='DD/MM/YYYY'
                        style={{ width: '100%', height: '38px' }}
                        required
                      />
                      {deuDateError && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>
                      Date of Incident <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative', backgroundColor: '#fff' }}
                    >
                      <input
                        type='text'
                        name='incidentDate'
                        placeholder='Select Date of Incident'
                        value={incidentDate}
                        // readOnly
                        onClick={handleIncidentDateClick}
                        // className="form-control"
                        className={`form-control ${incidentClass ? 'is-invalid' : ''}`}
                        // onBlur={() => setIncidentClass(!incidentDate)} // Toggle error if empty
                        // aria-invalid={!incidentDate}
                        style={{ cursor: 'pointer', paddingRight: '30px' }} // Add space for icon
                        required
                      />

                      {/* Dropdown Icon */}
                      <FaCaretDown
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          pointerEvents: 'none',
                          color: '#888',
                        }}
                      />
                      {incidentClass && (
                        <div className='invalid-feedback'>
                          Date of Incident is required.
                        </div>
                      )}
                      {/* Autocomplete List */}
                      {showAutocomplete && (
                        <div className='firstName-dropdown'>
                          <AutoAppointmentComplete
                            type={appointmentDates}
                            onFsListItem={(item) =>
                              handleSelectDate(item, setFieldValue)
                            }
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <label>
                      Staff / Doctor Involved{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative' }}
                    >
                      <input
                        type='text'
                        name='doctorInvolved'
                        placeholder='Search Doctor'
                        value={
                          smsTemplate.doctorInvolved
                            ? smsTemplate.doctorInvolved
                            : doctorName
                        }
                        className='form-control'
                        onChange={onSearchDoctor}
                        required
                      />

                      {/* Autocomplete Dropdown */}
                      {isDoctorList && (
                        <div className='firstName-dropdown'>
                          <Autocomplete
                            type={doctorList}
                            onFsListItem={(item) => onDoctorItem(item)}
                          />
                        </div>
                      )}

                      {/* Loading Spinner */}
                      {doctorLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '6px',
                            right: '20px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <label>Date of Acknowledgement</label>
                    <Form.Group className='mb-3'>
                      <DatePicker
                        value={acknowledgementDate}
                        onChange={handleDateAcknowledgementChange}
                        format='DD/MM/YYYY'
                        style={{ width: '100%', height: '38px' }}
                        placeholder='DD/MM/YYYY'
                      />
                      {deuDateError && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Deadline Date</label>
                    <Form.Group className='mb-3'>
                      <DatePicker
                        value={deadlineDate}
                        onChange={handleDeadlineDateChange}
                        format='DD/MM/YYYY'
                        style={{ width: '100%', height: '38px' }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Final Reply Date</label>
                    <Form.Group className='mb-3'>
                      <DatePicker
                        value={replyDate}
                        onChange={handleReplyDate}
                        format='DD/MM/YYYY'
                        style={{ width: '100%', height: '38px' }}
                        placeholder='DD/MM/YYYY'
                      />
                      {deuDateError && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>
                      Outcome <span style={{ color: 'red' }}>*</span>{' '}
                    </label>
                    <Form.Group className='mb-2'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.outcome}
                        name='outcome'
                        // onChange={handleChange}
                        onChange={(e) => {
                          handleChange(e);
                          setSmsTemplate({
                            ...smsTemplate,
                            outcome: e.target.value,
                          });
                        }}
                        required
                        onBlur={handleBlur}
                        style={{ borderColor: errors.outcome ? 'red' : '' }}
                        error={errors.outcome}
                        touched={touched.outcome}
                        // required
                        selectData={outcome}
                      />
                      {validationError.outcome && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Notes</label>
                    <Form.Group className='mb-3'>
                      <textarea
                        cols='60'
                        rows='3'
                        style={{ borderColor: errors.notes ? 'red' : '' }}
                        name='notes'
                        className='form-control'
                        placeholder='Notes'
                        value={values.notes}
                        onBlur={handleBlur}
                        error={errors.notes}
                        touched={touched.notes}
                        onChange={(e) => {
                          const transformedValue = e.target.value.replace(
                            /(^\s*\w|[\.\!\?]\s*\w)/g,
                            (match) => match.toUpperCase()
                          );

                          handleChange({
                            target: {
                              name: e.target.name,
                              value: transformedValue,
                            },
                          });

                          // Also update smsTemplate with transformed text
                          setSmsTemplate({
                            ...smsTemplate,
                            notes: transformedValue,
                          });
                        }}
                        // onChange={(e) => {
                        //   handleChange(e); // Update form state
                        //   setSmsTemplate({
                        //     ...smsTemplate,
                        //     notes: e.target.value, // Update smsTemplate
                        //   });
                        // }}
                        ////style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {validationError.notes && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <div className='my-4 mb-3 p-2 d-flex'>
                  <CustomButtons
                    buttonDisabled={addJobDisabled}
                    type='submit'
                    variant='primary'
                    name={btnDisable ? 'Loading...' : 'Save'}
                  />
                  <CustomDangerButton
                    cancelOnClick={() => setShowPatientForm(false)}
                    variant='danger'
                    name='Cancel'
                  />
                </div>
              </Form>
            )}
          </Formik>
        </Card>
      ) : (
        <p>loading...</p>
      )}
    </div>
  );
}

export default ComplaintForm;
